import {ChangeDetectorRef, Component, Input, OnChanges, OnInit} from '@angular/core';
import {SeasonsService} from '../seasons.service';
import {GlobalService} from '../../../global.service';
import {MatDialog, MatDialogModule} from '@angular/material';
import {AuthenticationService} from '../../../authentication.service';
import {SignupDialogComponent} from './signup-dialog/signup-dialog.component';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import { Output, EventEmitter } from '@angular/core';
import {TeamSignupComponent} from './team-signup/team-signup.component';
import {TeamEventsService} from '../../team-events/team-events.service';
import {ConfirmDialogService} from '../../../shared/confirm-dialog/confirm-dialog.service';
import {DomSanitizer} from '@angular/platform-browser';
import {BroadCastService} from '../../../broadcast.service';
import {AccServerConnectorComponent} from '../../seasonsv2/acc-server-connector/acc-server-connector.component';
import {JoinR3eServerComponent} from '../../seasonsv2/join-r3e-server/join-r3e-server.component';
import {Router} from '@angular/router';

@Component({
  selector: 'elastic-race-signup',
  templateUrl: './race-signup.component.html',
  styleUrls: ['./race-signup.component.scss']
})
export class RaceSignupComponent implements OnInit, OnChanges {

  @Input() race: any;
  @Input() event: any;
  @Output() registered = new EventEmitter<string>();
  @Input() signedUp: boolean;

  @Input() AdditionalButtons = true;

  @Input() smallButtons = false;
  @Input() colors = false;

  raceRoomContent = [];

  cars = [];

  date: Date;

  ifr = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");

  constructor(
    private seasonsService: SeasonsService,
    private cdr: ChangeDetectorRef,
    private globalService: GlobalService,
    private dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private teamEventsService: TeamEventsService,
    private confirmDialogService: ConfirmDialogService,
    private sanitizer: DomSanitizer,
    private broadcastService: BroadCastService,
    private router: Router
  ) { }

  ngOnInit() {
    this.date = new Date();
  }

  ngOnChanges(changes: any): void {
    this.event.minimum_sr = this.event.min_sr;
    this.event.maximum_sr = this.event.max_sr;
  }

  openBriefing() {
    if (this.event.sim_id == 2 && this.event.team_event == 1) {
      window.open('https://drive.google.com/file/d/19ByyfVzYreny-GwFJV6gqKrfN-VjKh2j/view?usp=sharing');
    }
    if (this.event.sim_id == 1 && this.event.team_event == 1) {
      window.open('https://drive.google.com/file/d/1tGL88W5HJNefEEeNHaE_yatWfKsgFIc-/view?usp=sharing');
    }
    if (this.event.sim_id == 3) {
      window.open('https://drive.google.com/file/d/1-tkfmcWHwuDB9ukOdnB15kP0pWU83SAv/view?usp=sharing');
    }
  }

  openSignupDialog(signedUp) {

    if (this.authenticationService.isLoggedIn()) {



      if (this.event.sim_id == 6 && this.authenticationService.currentUser.raceroom_id == 0) {

        this.globalService.updateRaceRoomId(this.authenticationService.getUserId()).subscribe((data: any) => {

          this.authenticationService.updateUserCookie();

          if (this.authenticationService.currentUser.raceroom_id == 0) {
            if (confirm("You need to enter your RaceRoom Username first under 'My Account'")) {
              this.router.navigateByUrl('/users');
              return;
            } else {
              this.router.navigateByUrl('/users');
              return;
            }
          } else {
              this.globalService.getUserRaceRoomContent(this.authenticationService.getUserId()).subscribe( (data:any) => {
                if (data) {
                  this.raceRoomContent = data.content_ids;
                  this.cdr.detectChanges();
                }
              });
          }

        });

      }


      if (this.event.team_event == 1) {
        if (signedUp) {
          this.teamEventsService.checkRaceTeamAdmin(this.race.race_id).subscribe( (data: any) => {
            if (data) {
              if (data.is_team_admin == 1) {
                this.dialog.open(TeamSignupComponent, {
                  data: {race: this.race, event: this.event, signedUp: signedUp}, width: "800px"
                }).afterClosed().subscribe(resp => {
                  if (resp) {
                    //console.log(resp);
                    this.registered.emit('registered');
                    this.broadcastService.sendMessage('registered');
                  }
                });
              } else {

                const options = {
                  title: 'Information',
                  message: 'You are not the registrar of the car! Changes only possible by the original registrar of the car!',
                  cancelText: '',
                  confirmText: 'OK'
                };
                this.confirmDialogService.open(options);

              }
            }
          });
        } else {
          this.dialog.open(TeamSignupComponent, {
            data: {race: this.race, event: this.event, signedUp: signedUp}, width: "800px"
          }).afterClosed().subscribe(resp => {
            if (resp) {
              //console.log(resp);
              this.registered.emit('registered');
              this.broadcastService.sendMessage('registered');
            }
          });
        }

      } else {

        this.dialog.open(SignupDialogComponent, {
          data: {race: this.race, event: this.event, signedUp: signedUp, raceRoomContent: this.raceRoomContent}
        }).afterClosed().subscribe(resp => {
          if (resp) {
            //console.log(resp);
            this.registered.emit('registered');
            this.broadcastService.sendMessage('registered');
          }
        });
      }
    } else {
      this.authenticationService.redirectToLogin();
    }

  }

  withdraw() {



    if (this.authenticationService.isLoggedIn()) {


      const options = {
        title: 'Are you sure?',
        message: 'Do you really want to withdraw from the race?',
        cancelText: 'No',
        confirmText: 'Yes'
      };
      this.confirmDialogService.open(options);
      this.confirmDialogService.confirmed().subscribe(confirmed => {
        if (confirmed) {
          if (this.event.team_event == 1) {
            this.teamEventsService.withdrawSeasonRace(this.event.event_id, this.race.race_id).subscribe( (data) => {
                this.registered.emit('registered');
              this.broadcastService.sendMessage('registered');
              }
            );
          } else {
            this.seasonsService.withdraw(this.race.race_id).subscribe(
              ( response: HttpEvent<any> ) => {
                switch (response.type) {
                  case HttpEventType.Response:
                    this.registered.emit('registered');
                    this.broadcastService.sendMessage('registered');
                    break;
                }
              });
          }
        }
      });
    }

  }

  test() {
    this.authenticationService.updateUserCookie();
    console.log(this.globalService.licenseRanks[this.authenticationService.getUserSimLicense(this.event.sim_id)]*1);
    console.log(this.globalService.licenseRanks[this.event.min_license]*1);
  }

  checkSignUpPossible() {

    //return false;

    this.date = new Date();


    //race.isLive === 1 ||  ||  || ()

    if (this.globalService.licenseRanks[this.authenticationService.getUserSimLicense(this.event.sim_id)]*1 < this.globalService.licenseRanks[this.event.min_license]*1) {
      return true;
    }

    if (this.race.isLive === 1) {
      return true;
    }

    if (this.race.registered >= this.event.slots) {
      return true;
    }

    if (this.authenticationService.getUserSr() < this.event.minimum_sr) {
      return true;
    }

    if ((this.event.maximum_sr != 0 && this.authenticationService.getUserSr() > this.event.maximum_sr) && this.globalService.licenseRanks[this.authenticationService.getUserSimLicense(this.event.sim_id)]*1 > this.globalService.licenseRanks[this.event.min_license]*1) {
      return true;
    }

    if (this.race.signupStartDate > new Date() ) {
      return true;
    }

    return false;

  }

  joinServer(race_id) {

    this.globalService.getJoinLink(race_id).subscribe((data: any) => {
      if (data) {

        const options = {
          title: 'rFactor2!',
          message: 'Is your rFactor2 Game running? Answer with "yes" if it is running. If you want us to start your rf2 and connect to the server, answer with "no"! If you have issues with a blank rf2 screen, close rf2 and try to let the website open rf2 for you with answering "no".',
          cancelText: 'No, please start it and connect me',
          confirmText: 'Yes its running'
        };
        this.confirmDialogService.open(options);
        this.confirmDialogService.confirmed().subscribe(confirmed => {
          if (confirmed) {
            document.location.href = atob(data.rfrunning);
            //this.ifr = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            //this.ifr = this.sanitizer.bypassSecurityTrustResourceUrl(atob(data.rfrunning));
          } else {
            document.location.href = atob(data.link);
            //this.ifr = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            //this.ifr = this.sanitizer.bypassSecurityTrustResourceUrl(atob(data.link));
          }
        });
      }
    });
  }

  joinAcServer(race_id) {

    this.globalService.getJoinLink(race_id).subscribe((data: any) => {
      if (data) {
        document.location.href = atob(data.link);
      }
    });
  }

  joinAMS2Server(race_id) {

    this.globalService.getJoinLink(race_id).subscribe((data: any) => {
      if (data) {
        const options = {
          title: 'AMS2',
          message: 'You want to start your game using Monitor or VR Mode?',
          cancelText: 'Give me those screens!',
          confirmText: 'I want to use my VR goggles!'
        };
        this.confirmDialogService.open(options);
        this.confirmDialogService.confirmed().subscribe(confirmed => {
          console.log(confirmed);
          if (confirmed) {
            //@ts-ignore
            window.location.href = atob(data.link) + '%20+forcevr';

          } else {
            //@ts-ignore
            window.location.href = atob(data.link);
          }
        });
      }
    });
  }

  joinAccServer(race_id) {

    this.globalService.getJoinLink(race_id).subscribe((data: any) => {
      if (data) {

        this.dialog.open(AccServerConnectorComponent, {
          data: data
        }).afterClosed().subscribe( (resp) => {
          document.location.href = atob(data.link);
        });

      }
    });
  }

  joinR3EServer(race_id) {

    this.globalService.getJoinLink(race_id).subscribe((data: any) => {
      if (data) {
        data.server_type = 'race';
        this.dialog.open(JoinR3eServerComponent, {
          data: data
        }).afterClosed().subscribe( (resp) => {

        });

      }
    });
  }

  autoJoin(race_id) {
    this.globalService.getJoinLink(race_id).subscribe((data: any) => {
      if (data) {
            this.ifr = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            this.ifr = this.sanitizer.bypassSecurityTrustResourceUrl(atob(data.rfrunning));
      }

      });
  }

}
